import { render, staticRenderFns } from "./UserEditor.vue?vue&type=template&id=18392bb9&"
import script from "./UserEditor.vue?vue&type=script&lang=ts&"
export * from "./UserEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports